import { render, staticRenderFns } from "./UseForSection.vue?vue&type=template&id=63648be3"
import script from "./UseForSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./UseForSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports